export default __webpack_public_path__ + "static/media/honeymobile3.39518f6d.webp";